var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-screen flex overflow-hidden bg-gray-100" },
    [
      _c("div", { staticClass: "hidden md:flex md:flex-shrink-0" }, [
        _c("div", { staticClass: "flex flex-col w-64" }, [
          _c(
            "div",
            {
              staticClass:
                "flex flex-col h-0 flex-1 border-r border-gray-200 bg-white"
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex-1 flex flex-col pt-5 pb-4 overflow-y-auto"
                },
                [
                  _c(
                    "nav",
                    { staticClass: "mt-5 flex-1 px-2 bg-white space-y-1" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass:
                            " text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md",
                          attrs: {
                            to: { name: "AutomationConfigure" },
                            "exact-active-class": "bg-gray-100 text-gray-900"
                          }
                        },
                        [_vm._v(" Abandoned carts ")]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass:
                            " text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md",
                          attrs: {
                            to: { name: "OrderConfirmation" },
                            "exact-active-class": "bg-gray-100 text-gray-900"
                          }
                        },
                        [_vm._v(" Order confirmation ")]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass:
                            " text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md",
                          attrs: {
                            to: { name: "OrderShippingUpdates" },
                            "exact-active-class": "bg-gray-100 text-gray-900"
                          }
                        },
                        [_vm._v(" Order Shipping updates ")]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass:
                            " text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md",
                          attrs: {
                            to: { name: "CodOrder" },
                            "exact-active-class": "bg-gray-100 text-gray-900"
                          }
                        },
                        [_vm._v(" COD order confirmation ")]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass:
                            " text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md",
                          attrs: {
                            to: { name: "MessageLogs" },
                            "exact-active-class": "bg-gray-100 text-gray-900"
                          }
                        },
                        [_vm._v(" Message logs ")]
                      ),
                      _c(
                        "router-link",
                        {
                          staticClass:
                            " text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md",
                          attrs: {
                            to: { name: "Faqs" },
                            "exact-active-class": "bg-gray-100 text-gray-900"
                          }
                        },
                        [_vm._v(" Faqs ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }